import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getTotalCartItems } from "../actions/cart.action";
import { AiOutlineArrowLeft, AiOutlineShoppingCart } from "react-icons/ai";

export default function TopNav({ link }) {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTotalCartItems());
  }, []);

  const {
    cart: { totalCartItems },
  } = useSelector(({ cartReducer }) => ({
    cart: cartReducer,
  }));

  const handleLink = () => {
    if (link !== undefined) {
      history.push(link);
    } else {
      history.goBack();
    }
  };

  return (
    <div className="flex justify-between mb-5 pointer-cursor">
      <AiOutlineArrowLeft
        size={25}
        onClick={() => handleLink()}
        className="cursor-pointer"
      />
      <div className="flex cursor-pointer">
        <AiOutlineShoppingCart
          size={25}
          onClick={() =>
            history.push("/dashboard/user/document-processing/cart-orders")
          }
        />
        <div>{totalCartItems}</div>
      </div>
    </div>
  );
}
